import { FaDollarSign } from 'react-icons/fa'
import { AiFillCheckCircle } from 'react-icons/ai'
import { MdOutlinePayments } from 'react-icons/md'
import { FiChevronLeft } from 'react-icons/fi'

import { Link } from 'react-router-dom'
import Table from 'rc-table'
import { useEffect, useState } from 'react'
import axios from 'axios'
import { PaymentLastes, PaymentSettlement } from '../api/api'
import Loading from './Loading'

const columns = [
  {
    title: 'مبلغ تسویه',
    dataIndex: 'tb1',
    key: 'tb1',
    width: 100
  },
  {
    title: 'تاریخ واریز',
    dataIndex: 'date',
    key: 'date',
    width: 100
  },
  {
    title: 'شناسه انتقال',
    dataIndex: 'payid',
    key: 'payid',
    width: 100
  },
  {
    title: 'توضیحات',
    dataIndex: 'whidrawid',
    key: 'whidrawid',
    width: 100
  }
]


export const separate = (Number) => {
  Number += '';
  Number = Number.replace(',', '');
  let x = Number.split('.');
  let y = x[0];
  let z = x.length > 1 ? '.' + x[1] : '';
  var rgx = /(\d+)(\d{3})/;
  while (rgx.test(y))
    y = y.replace(rgx, '$1' + ',' + '$2');
  return y + z;
}



export default function PaymentHistory() {


  const [isLoading, setIsLoading] = useState(false)
  const [tableData, setTableData] = useState([])
  const [paymentData, setPaymentData] = useState([])


  useEffect(() => {
    const getData = async () => {

      try {
        setIsLoading(true)
        const res = await axios.get(PaymentLastes(1))
        const res1 = await axios.get(PaymentSettlement)
        setPaymentData(res1.data)

        for (let i = 0; i < res.data.length; i++) {

          setTableData(s => {
            return [
              ...s,
              {
                tb1: (<>{separate(res.data[i].price)}</>),
                date: res.data[i].payDate,
                payid: res.data[i].trackingCode,
                key: i,
                whidrawid: res.data[i].description
              }
            ]
          })

        }
      } finally {
        setIsLoading(false)
      }
    }

    getData()
  }, []);



  return (
    <>
      <div className='searchTypeRow'>
        <div className='breadcrumb'>
          <Link to={'/profile'}>پروفایل</Link>

          <span className='spacer'>
            <FiChevronLeft />
          </span>

          <span className='current'>لیست تسویه ها</span>
        </div>
      </div>

      <div className='contentHolder'>
        <div className='row'>
          {/*  */}
          <div className='col-md-4'>
            <div className='flex box_radios paymenthistory purple'>
              <div className='iconHolder'>
                <FaDollarSign />
              </div>
              <div className='dtHolder'>
                <p>مبلغ کل درآمد از ابتدا</p>
                {isLoading ? '...' : <b>{separate(paymentData?.totalIncome)} تومان</b>}
              </div>
            </div>
          </div>

          <div className='col-md-4'>
            <div className='flex box_radios paymenthistory'>
              <div className='iconHolder'>
                <AiFillCheckCircle />
              </div>
              <div className='dtHolder'>
                <p>درآمدهای تسویه شده تا کنون</p>
                {isLoading ? '...' : <b>{separate(paymentData?.totalSettlementIncome)} تومان</b>}
              </div>
            </div>
          </div>

          <div className='col-md-4'>
            <div className='flex box_radios paymenthistory green'>
              <div className='iconHolder'>
                <MdOutlinePayments />
              </div>
              <div className='dtHolder'>
                <p>موجودی</p>
                {isLoading ? '...' : <b>{separate(paymentData?.credit)} تومان</b>}
              </div>
            </div>
          </div>
          {/*  */}
        </div>

        <div className='row'>
          <div className='col-md-12'>
            <div className='box_radios'>
              <div className='headHolder'>
                <p className='title'>لیست تسویه ها</p>
              </div>
              {isLoading ? <Loading styles='mini' /> : <Table columns={columns} data={tableData} tableLayout='auto' />}
            </div>
          </div>
        </div>
      </div>
    </>
  )
}
